import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkerCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMarkerCircle"><Path d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 18.5C7.5 17.5 7.5 14.5 7.5 14.5H16.5C16.5 14.5 16.5 17.5 18.5 18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 14.25V9.5L15.5 8V14.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMarkerCircle;
